import {APIRequest} from "../APIRequest.js";
import {GAEvent} from "../../App/GA";
import {getQueryParamValue, isMobile} from "../../App/utils";
import {getPlatform, isWindows} from "../../utils";

export const AUTH_API_URL = "https://lq5zc6qzy54epd4uppiekqdigm0mlitk.lambda-url.us-east-1.on.aws/";

const timeout = 20000;

export const fetchKBJWT = async (kbId, isShared) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'fetchKBJWT';
    const params = {
        token,
        kbId,
        isShared,
        // expTime: 5
    };

    const res = await APIRequest('post', AUTH_API_URL + action, params, {
        headers: {
            'Content-Type': 'application/json',
        }
    });

    return res;
}

export const fetchClientJWT = async ({signup, inputJWT, subscribed}) => {
    const params = {
        inputJWT,
        signup,
        // expTime: 10
    };

    if (signup) {
        const browserInfo = {
            userAgent: navigator?.userAgent,
            platform: navigator?.platform,
            vendor: navigator?.vendor,
            language: navigator?.language,
            languages: navigator?.languages,
            deviceMemory: navigator?.deviceMemory || 'unknown',
            hardwareConcurrency: navigator?.hardwareConcurrency || 'unknown',
        };

        params.href = window.location.href;
        params.referrer = document.referrer;
        params.isMobile = isMobile;
        params.platform = getPlatform() + ' | ' +  JSON.stringify(browserInfo);
        params.subscribed = subscribed;
    }

    if (getQueryParamValue('ip')) params.ip = getQueryParamValue('ip');
    return await APIRequest('post', AUTH_API_URL, params, {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export const uploadImage = async (base64Image) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'uploadImage';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            base64Image
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
}

export const verifyPhoneCode = async (code) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'verifyPhoneCode';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            code
        }, {timeout});

        // if (response?.data) GAEvent({ category: "engagement", action: "Verify Phone Code Success" });

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const cancelPhoneVerification = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'cancelPhoneVerification';

    // GAEvent({ category: "engagement", action: "Cancel Phone Verification"});

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const sendPhoneVerificationCode = async (phone, country) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'sendPhoneVerificationCode';

    // GAEvent({ category: "engagement", action: "Send Phone Verification Code" });

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            phone,
            country
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const updateUserBilling = async (billingInfo) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'updateUserBilling';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            billingInfo,
        }, { timeout });

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const listInvoices = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'listInvoices';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, { token }, { timeout });
        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const downloadInvoice = async (invoiceId, isReceipt) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'downloadInvoice';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, { token, invoiceId, isReceipt }, { responseType: 'arraybuffer' });
        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const getUserBilling = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'getUserBilling';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, { token }, { timeout });
        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};


export const updateUser = async ({phone, name}) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'updateUser';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            phone,
            name
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const PHONE_VERIFICATION_STATUS = {
    NOT_VERIFIED: 'NOT_VERIFIED',
    IN_PROGRESS: 'IN_PROGRESS',
    VERIFIED: 'VERIFIED',
    CANCELED: 'CANCELED',
}

export const getAccountId = async () => {
    const token = localStorage.getItem('kbJWT');
    const action = 'getAccountId';
    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

let getUserProfilePromise = null; // This will hold the promise for the ongoing request

export const getUserProfile = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'getUserProfile';

    // If there's an ongoing request, return the existing promise
    if (getUserProfilePromise) return getUserProfilePromise;

    // Create a new promise for the request
    getUserProfilePromise = (async () => {
        try {
            const response = await APIRequest('post', AUTH_API_URL + action, {
                token
            }, {timeout});

            if (response?.data?.status === 404) {
                return {
                    name: 'User not found',
                    picture: '',
                }
            }

            return response?.data;
        } catch (error) {
            console.error('API request error:', error);
            throw error;
        } finally {
            // Once the request is completed, reset the promise to allow future requests
            getUserProfilePromise = null;
        }
    })();

    return getUserProfilePromise;
};

